
<template>
    <div class="action_field in_memor" v-if="obj_to_null(this.field)">
        <div class="field_insert small ">{{field.number}}</div>
        <div class="field_insert small tdtp">{{field.tdtp}}</div>
        <div class="field_insert bold small kp">{{field.kp_code}}</div>
        <div class="field_insert main_big">{{field.dolznost}}</div>
        <div class="field_insert bold big">{{field.qual_shtat}}</div>
        <div class="field_insert big">{{field.hour_stavka}}</div>
        <div class="field_insert bold medium mpo">{{field.month_money | toNiceNumber}}</div>
        <div class="field_insert small">{{field.is_bad}}</div>
        <div class="field_insert big">{{field.doplata}}</div>
        <div class="field_insert bold medium ">{{field.max_doplata}}</div>
        <div class="field_insert bold medium mpo">{{field.all_money | toNiceNumber}}</div>
        <div class="field_insert bold medium">{{field.do_vupl | toNiceNumber}}</div>
        <div class="field_insert bold medium last-child">{{field.all_fop | toNiceNumber}}</div>
    </div>
</template>


<script >
export default {
    name: "kadr_field",
    props : {
        field : {
            type : Object,
            require : true,
        }
    }
}
</script>


<style scoped>

</style>